.filters {
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;
  gap: 1em;
  font-size: 1rem;
  letter-spacing: normal;
}

.searchInput {
  width: 100%;
  /* Override the default margin of the purecss input on mobile */
  margin-bottom: 0 !important;
}

input:placeholder-shown + .resetSearchButton {
  display: none;
}

input:focus + .resetSearchButton {
  border-color: var(--highlight-blue);
}

.resetSearchButton {
  appearance: none;
  touch-action: manipulation;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: color-mix(in srgb, var(--font-color) 50%, transparent);
  border-bottom: var(--border);
  text-align: center;
  padding: 5px 10px;
  line-height: 1;
  transition: border-color 0.2s;
}
